import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Result } from "antd";

function RedirectLoginForUnAuth() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(9); // Initial countdown value

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1); // Decrement countdown
    }, 1000);
    // Cleanup function to clear interval when component unmounts
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Redirect when countdown reaches 0
    if (countdown === 0) {
      navigate("/");
    }
  }, [countdown]);

  return (
    <Result
      status="403"
      title="403"
      subTitle={
        <span>
          Your session may have expired or you are not authorized to access this
          page. Please try logging in again. Redirecting in...
          {<span className="ms-1 font-extrabold">{countdown}</span>} seconds.
        </span>
      }
      extra={<Button onClick={() => navigate("/")}>Please Login</Button>}
    />
  );
}

export default RedirectLoginForUnAuth;
